import classNames from '@utils/classnames';
import React, { MouseEvent } from 'react';

export interface IActionMenuItemProps {
  onTrigger: (evt: MouseEvent<HTMLButtonElement>) => void;
  isDisabled?: boolean;
  isDanger?: boolean;
  iconLeft?: React.ReactElement;
  children: React.ReactNode;
}

export const ActionMenuItem: React.FC<IActionMenuItemProps> = (props) => {
  const { onTrigger, isDisabled, isDanger, iconLeft, children } = props;

  return (
    <button
      type="button"
      onClick={onTrigger}
      disabled={isDisabled}
      className={classNames(
        'flex h-9 w-full items-center gap-2.5 rounded-md px-2.5 text-left text-sm transition-colors',
        isDisabled
          ? 'cursor-default text-fg-muted'
          : isDanger
            ? 'text-negative-text hover:bg-negative-subtle'
            : 'text-fg hover:bg-surface-hover',
      )}
    >
      {iconLeft && (
        <span
          className={classNames('flex w-4 shrink-0 items-center justify-center [&>svg]:h-4 [&>svg]:w-4', {
            'text-fg-muted': !isDanger && !isDisabled,
          })}
        >
          {iconLeft}
        </span>
      )}
      <span className="flex-1">{children}</span>
    </button>
  );
};
